import React, { useState } from 'react';
import { Card } from '../../../components/CssFrameworkComponents';
import SettingsToggleRow from '../components/SettingsToggleRow';
import ForceHTTPSConfirmModal from './ForceHTTPSConfirmModal';
import { useAutoSaveSetting } from '../hooks/useAutoSaveSetting';
import { useOptimisticChecked } from '../hooks/useOptimisticChecked';
import { usePrerenderUser } from '../../../hooks/usePrerenderUser';
import { SETTINGS_RESTRICTED_ROLES } from '../settingsRoles';

const TITLE = 'Enforce HTTPS Protocol';

const DESCRIPTIONS = [
  // eslint-disable-next-line max-len
  'When this configuration is applied, the rendering servers will only call your site through HTTPS (secure connection), even if the original request was made for an HTTP (not encrypted version).',
  // eslint-disable-next-line max-len
  "Usually, this doesn't change the site's content. The only exception is for unique circumstances when you can configure the origin server to serve different content. In that case, it may cause an issue.",
];

const ForceHTTPSCard = () => {
  const { settings } = usePrerenderUser();
  const { save, status, retry } = useAutoSaveSetting();
  const { checked, setPendingChecked } = useOptimisticChecked(settings.forceHTTPS, status);
  const [confirmVisible, setConfirmVisible] = useState(false);

  const onChange = (newChecked) => {
    if (newChecked) {
      // Enabling is destructive: don't flip the toggle until the user confirms in the modal.
      setConfirmVisible(true);
    } else {
      setPendingChecked(false);
      save({ forceHTTPS: false });
    }
  };

  const onConfirm = () => {
    setPendingChecked(true);
    save({ forceHTTPS: true });
    setConfirmVisible(false);
  };

  return (
    <Card title={TITLE}>
      <div className="col">
        {DESCRIPTIONS.map((description) => (
          <div className="row" key={description}>
            <p>{description}</p>
          </div>
        ))}
        <SettingsToggleRow
          checked={checked}
          onChange={onChange}
          disabled={status === 'saving'}
          disabledFor={SETTINGS_RESTRICTED_ROLES}
          status={status}
          onRetry={retry}
        />
      </div>
      <ForceHTTPSConfirmModal open={confirmVisible} onOk={onConfirm} onCancel={() => setConfirmVisible(false)} />
    </Card>
  );
};

export default ForceHTTPSCard;
